<template>
    <div>
        <ul class="uk-list uk-list-line">
            <li class="uk-grid uk-grid-small">
                <div class="uk-width-1-2">
                    <h6>Time Banks</h6>
                </div>
                <div class="uk-width-1-4 uk-text-right">
                    <h6>Remaining</h6>
                </div>
                <div class="uk-width-1-4 uk-text-right">
                    <h6>Projected</h6>
                </div>
            </li>
            <li
                v-for="property in user_benefits()"
                :key="property.id"
                class="uk-grid uk-grid-small"
            >
                <div class="uk-width-1-2">
                    {{ property.label }}
                </div>
                <div class="uk-width-1-4 uk-text-right" :class="{'uk-text-danger': (amount_left(property.id) < 0)}">
                    <span v-if="property.monetary">
                        $ {{ amount_left(property.id) | nibnut.number("0,0.00") }}
                    </span>
                    <span v-else>
                        {{ amount_left(property.id) | nibnut.number("0,0.00") }} {{ property.unit || "hrs" }}
                    </span>
                </div>
                <div class="uk-width-1-4 uk-text-right" :class="{'uk-text-danger': amount_projection_not_approved(property.id)}">
                    <span v-if="property.monetary">
                        $ {{ amount_projected(property.id) | nibnut.number("0,0.00") }}
                    </span>
                    <span v-else>
                        {{ amount_projected(property.id) | nibnut.number("0,0.00") }} {{ property.unit || "hrs" }}
                    </span>
                </div>
            </li>
        </ul>

        <ul class="uk-list uk-list-line uk-margin-large-top">
            <li class="uk-grid uk-grid-small">
                <div class="uk-width-3-4">
                    <h6>Stipends</h6>
                </div>
                <div class="uk-width-1-4 uk-text-right">
                    <h6>Remaining</h6>
                </div>
            </li>
            <li
                v-for="property in user_stipends"
                :key="property.id"
                class="uk-grid uk-grid-small"
            >
                <div class="uk-width-3-4">
                    {{ property.label }}
                </div>
                <div class="uk-width-1-4 uk-text-right" :class="{'uk-text-danger': (amount_left(property.id, property.monetary) < 0)}">
                    <span v-if="property.monetary">
                        $ {{ amount_left(property.id) | nibnut.number("0,0.00") }}
                    </span>
                    <span v-else>
                        {{ amount_left(property.id) | nibnut.number("0,0.00") }} hrs
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script type="text/javascript">
import { mapState } from "vuex"

import dashboard_card from "./dashboard_card"
import profile_utilities from "../../mixins/ProfileUtilities"

export default {
    mixins: [dashboard_card, profile_utilities],
    methods: {
        amount_allotted (property) {
            return this.record ? this.record[property] || 0 : 0
        },
        amount_used (property) {
            return this.record ? this.record[property + "_used"] || 0 : 0
        },
        amount_left (property) {
            return this.amount_allotted(property) - this.amount_used(property)
        },
        amount_projected (property) {
            let days_off = 0
            if(this.record && this.record.time_off) {
                const today = this.$moment({ hour: 0 })
                this.record.time_off.filter(off_period => {
                    return this.$moment(off_period.starts_at).startOf("day").isSameOrAfter(today) && (off_period.benefit === property)
                }).forEach(off_period => {
                    const off_date = this.$moment(off_period.starts_at).startOf("day")
                    const back_to_work_date = this.$moment(off_period.ends_at).endOf("day")
                    days_off += this.$moment().isoWeekdayCalc(off_date, back_to_work_date, [1, 2, 3, 4, 5])
                    // if(property === "vacation_hours") console.log({ off_date, back_to_work_date, delta: this.$moment().isoWeekdayCalc(off_date, back_to_work_date, [1, 2, 3, 4, 5]), days_off })

                    for(off_date; off_date.isBefore(back_to_work_date); off_date.add(1, "days")) {
                        if(this.holiday(off_date)) days_off--
                    }
                    // if(property === "vacation_hours") console.log({ days_off })
                })
            }
            return (days_off * this.$root.applicationSettings.work_day_hours)
        },
        amount_projection_not_approved (property) {
            if(this.record && this.record.time_off) {
                return !!this.record.time_off.find(off_period => {
                    return this.$moment(off_period.starts_at).startOf("day").isSameOrAfter(this.$moment({ hour: 0 })) && (off_period.benefit === property) && !off_period.approved
                })
            }
            return false
        },
        holiday (date) {
            if(!this.holidays || !this.holidays.length) return false
            return !!this.holidays.find(holiday => {
                return date.isSameOrAfter(holiday.starts_at) && date.isSameOrBefore(holiday.ends_at)
            })
        }
    },
    computed: {
        ...mapState(["holidays"])
    }
}
</script>
